/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";
import Navbar from "react-bootstrap/Navbar";

import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";
import {NewSignInButton} from "./NewSignInButton"
import { Layout, Row, Col } from "antd"
import ciplaLogo from "../images/cipla-logo.png";

const { Header } = Layout

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props 
 */
export const PageLayout = (props) => {
    const isAuthenticated = useIsAuthenticated();

    return (
        <>
            <Header className="header">
                <Row>
                    <Col xs={18} sm={24} md={24} lg={24} xl={24}>
                        <div className="logo">
                            <img src={ciplaLogo} style={{ width: '70px' }} />
                        </div>
                    </Col>
                </Row>
            </Header>

            <Navbar bg="primary" variant="dark" style={{ display: 'none' }}>
                <a className="navbar-brand" href="/">Cipla Login</a>
            </Navbar>
            <br />
            <h5><center>Welcome to Cipla Invoicing Application</center></h5>
            <br />
            <br />
            <center>
                {isAuthenticated ?
                    <SignOutButton /> :
                    // <SignInButton />
                    <NewSignInButton/>
                }
            </center>
            {props.children}
        </>
    );
};
